/** Shared RTK Query options for schedule endpoints — avoids refetch storms on window focus. */
export const scheduleQueryOptions = {
  refetchOnMountOrArgChange: true,
  refetchOnFocus: false,
  refetchOnReconnect: true,
} as const

export const scheduleProfileQueryOptions = {
  refetchOnMountOrArgChange: true,
  refetchOnFocus: false,
  refetchOnReconnect: true,
} as const
